import React from 'react';

import Popup from '../../Popup';
import styles from './welcomePopUps.scss';
import { VerifiedRulesLink } from '../../Links';

const MaxPostScoreDateCrossedPopUp = ({
    onCloseClick,
    onCtaClick,
}) => {
    return (
        <Popup
            className={`popup-md`}
            popUpClassName={`${styles.welcomePopUp}`}
            onCloseClick={onCloseClick}
            config={{
                noPadding: true,
                fullScreen: false,
                topGradient: false,
                scrollable: false,
            }}
        >
            <div className={`${styles.section} pt0`}>
                <h4>
                        Verified Event Complete
                </h4>
            </div>
            <div className={`${styles.section} pt0`}>
                <p>
                        Editing scores for this event is closed as this Verified Event closed more than 7 days ago. For questions, click here to view the <VerifiedRulesLink target="_blank">verified rules</VerifiedRulesLink>.
                </p>
                <div className="bb" />
                <button
                    type="button"
                    className="btn btn-primary btn-xl btn-block text-uppercase"
                    onClick={onCtaClick}
                >
                        Got It
                </button>
            </div>
        </Popup>
    );
};

export default MaxPostScoreDateCrossedPopUp;
